import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { LogOut, MessageSquare, Calendar } from 'lucide-react';
import AdminReviews from '../components/AdminReviews';
import AdminAppointments from './AdminAppointments';

export const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('reviews');
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab) setActiveTab(tab);
  }, [location]);

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const switchTab = (tab) => {
    setActiveTab(tab);
    navigate(`?tab=${tab}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold">Admin Dashboard</h1>
              <p className="text-gray-600 mt-1">Precision Mobile Detailing</p>
            </div>
            <div className="flex gap-4 items-center">
              <span className="text-gray-600">Welcome, {user?.email}</span>
              <Button onClick={handleLogout} variant="outline">
                <LogOut className="w-4 h-4 mr-2" /> Logout
              </Button>
            </div>
          </div>

          <div className="flex gap-2 mt-6">
            <Button
              onClick={() => switchTab('reviews')}
              variant={activeTab === 'reviews' ? 'default' : 'outline'}
              className={activeTab === 'reviews' ? 'cta-button' : ''}
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Reviews
            </Button>
            <Button
              onClick={() => switchTab('appointments')}
              variant={activeTab === 'appointments' ? 'default' : 'outline'}
              className={activeTab === 'appointments' ? 'cta-button' : ''}
            >
              <Calendar className="w-4 h-4 mr-2" />
              Appointments
            </Button>
          </div>
        </div>
      </div>

      <div className="py-8">
        {activeTab === 'reviews' && <AdminReviews />}
        {activeTab === 'appointments' && <AdminAppointments />}
      </div>
    </div>
  );
};

export default AdminDashboard;
